
import Vue from 'vue';

/**
 * Bottom Navigation Bar
 *
 * Navigation Bar on the bottom of the Application
 */
export default Vue.extend<any, any, any, any>({
  name: 'BottomNavBar',
  props: {
    /**
     * Navigation Bar List configuration.<br />
     * The model
     *
     * - `id`: `string` Identifier of the Navigation Bar
     * - `icon`: `function / object` The SVG component of the icon. Has parameters `active` (boolean) props
     * - `label`: `string` Label of the Navigation Bar
     */
    navBarList: {
      type: Array,
      default: () => []
    },
    /**
     * Active Tab of Navigation, bind with `v-model`
     */
    activeTab: String
  },
  model: {
    prop: 'activeTab'
  },
  methods: {
    isTabActive(tabId: string) {
      return this.activeTab === tabId;
    },
    handleClickNavBar(tabId: string) {
      /**
       * Handle when click the Tab of Navigation.<br />
       * Bind with `v-model`.
       * @event input
       */
      this.$emit('input', tabId);
      /**
       * Callback when click the Tab of Navigation.
       * @event click
       */
      this.$emit('click', tabId);
    }
  }
});
